import { Controller } from "@hotwired/stimulus"

// Reloads the broadcast show page every few seconds while a send is in flight, so
// the live sent/skipped/failed tallies and the result log settle to final without
// the operator manually refreshing. Stops once the send is done.
export default class extends Controller {
  static values = { active: Boolean, interval: { type: Number, default: 3000 } }

  connect() {
    if (this.activeValue) {
      this.timeout = setTimeout(() => window.location.reload(), this.intervalValue)
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
